// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.match-tabs-module{display:flex;flex-direction:column;align-self:stretch;width:100%}`, "",{"version":3,"sources":["webpack://./src/matchScreen/redesign/styles/MatchTabsModule/MatchTabsModule.scss"],"names":[],"mappings":"AAEA,mBACE,YAAA,CACA,qBAAA,CACA,kBAAA,CACA,UAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
